import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PhotoAlbumComponent } from "../_components/photo-album/photo-album.component";

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  imports: [CommonModule, PhotoAlbumComponent]
})
export class GalleryComponent implements OnInit {

  photos = [];

  constructor() { }

  ngOnInit() {
    //this.photos.push({src:'', title:'', description:''});
    this.photos.push({src:'https://services.ifa.com/art/images/3585_2026-5-6-12-30-14.jpg', title:'Raffaello Sanzio (Raphael), Madonna of Foligno', description:'(c. 1511 to 1512; High Renaissance)'});
    this.photos.push({src:'https://services.ifa.com/art/images/3585_2026-5-6-12-30-18.jpg', title:'Raffaello Sanzio (Raphael), The Transfiguration ', description:'(c. 1516 to 1520; High Renaissance)'});
    this.photos.push({src:'https://services.ifa.com/art/images/3585_2026-5-6-12-30-23.jpg', title:'Raffaello Sanzio (Raphael), Crowning of the Virgin/the Oddi Altarpiece ', description:'(c. 1502 to 1504; High Renaissance)'});
    this.photos.push({src:'https://services.ifa.com/art/images/3585_2026-5-6-12-30-33.jpg', title:'Carlo Crivelli, Pietà ', description:'(c. 1476; Late Gothic, Renaissance)'});
    this.photos.push({src:'https://services.ifa.com/art/images/3585_2026-5-6-12-30-45.jpg', title:'San Giacomo in Augusta, Rome; Dome: Silverio Capparoni, Apotheosis of St. James', description:'(c. 1862 and 1863; Neo-Baroque)'});
    this.photos.push({src:'https://services.ifa.com/art/images/3585_2026-5-6-12-30-51.jpg', title:'Antonio Allegri da Correggio (Correggio), Redeemer in Glory', description:'(c. 1525; High Renaissance)'});
  }



}
